/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { DatePickerInput } from 'rc-datepicker';
import PropTypes from 'prop-types';
import './BitaCalendarStyle.scss';
import styles from './BitaCalendar.module.scss';

const BitaCalendar = ({
  date,
  minDate,
  maxDate,
  select,
  title,
  toUpperCaseTitle = true,
  marginTitle = true,
}) => {
  const [dateSelect, setdateSelect] = React.useState(date || null);

  useEffect(() => {
    if (date) {
      setdateSelect(date);
    } else if (minDate && !dateSelect) {
      setdateSelect(minDate);
    }
  }, [date, minDate]);

  const onSelect = date => {
    setdateSelect(date);
    if (select) select(date);
  };

  return (
    <div className="CalendarDate">
      <div className={marginTitle ? styles.textMargin : styles.text}>
        {toUpperCaseTitle ? title.toUpperCase() : title}
      </div>
      <DatePickerInput
        onChange={onSelect}
        minDate={minDate}
        maxDate={maxDate || new Date()}
        displayFormat="YYYY/MM/DD"
        returnFormat="YYYY-MM-DD"
        showOnInputClick
        value={dateSelect}
        className="bita-calendar-date"
      />
    </div>
  );
};

BitaCalendar.propTypes = {
  date: PropTypes.instanceOf(Date),
  select: PropTypes.func.isRequired,
  title: PropTypes.string,
  toUpperCaseTitle: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  minDate: PropTypes.any,
  maxDate: PropTypes.instanceOf(Date),
};

BitaCalendar.defaultProps = {
  title: ' ',
  toUpperCaseTitle: true,
  date: null,
  minDate: null,
  maxDate: null,
};

export default BitaCalendar;
